<template>
  <yxt-drawer
    :title="$t('pc_menu_type_4')"
    :visible="visible"
    @close="handleCancel"
    size="480px"
    direction="rtl"
  >
    <yxt-form
      ref="formRef"
      class="form-box"
      :rules="rules"
      :model="formData"
      is-need-require
      is-need-tooltip
    >
      <yxt-form-item :label="$t('pc_select_type')">
        <yxt-radio-group
          v-model="formData.selType"
          @change="formData.auditType = 0"
        >
          <yxt-radio :label="0">{{$t('pc_radio_0')}}</yxt-radio>
          <yxt-radio :label="1">{{$t('pc_radio_1')}}</yxt-radio>
        </yxt-radio-group>
      </yxt-form-item>
      <yxt-form-item
        class="sel-type-item"
        v-if="formData.selType===1"
        :label="$t('pc_audit_multi')"
      >
        <yxt-radio-group v-model="formData.auditType">
          <yxt-radio :label="0">
            {{$t('pc_audit_or')}}
            <yxt-tooltip
              effect="dark"
              :content="$t('pc_audit_or_tip')"
            >
              <yxt-svg
                icon-class='question-cirlce-o'
                class="ml4 color-gray-7"
                width='16px'
                height='16px'
              ></yxt-svg>
            </yxt-tooltip>
          </yxt-radio>
          <yxt-radio :label="1">
            {{$t('pc_audit_and')}}
            <yxt-tooltip
              effect="dark"
              :content="$t('pc_audit_and_tip')"
            >
              <yxt-svg
                icon-class='question-cirlce-o'
                class="ml4 color-gray-7"
                width='16px'
                height='16px'
              ></yxt-svg>
            </yxt-tooltip>
          </yxt-radio>
        </yxt-radio-group>
      </yxt-form-item>
      <yxt-form-item :label="$t('pc_select_range')">
        <yxt-radio-group v-model="formData.selRange">
          <yxt-radio :label="0">
            {{$t('pc_all_role')}}
          </yxt-radio>
          <yxt-radio :label="1">{{$t('pc_assign_role')}}</yxt-radio>
        </yxt-radio-group>
      </yxt-form-item>
      <yxt-form-item
        v-if="formData.selRange === 1"
        :label="$t('pc_l_select_role')"
        prop="users"
      >
        <yxt-select
          v-model="formData.users"
          multiple
          :placeholder="$t('pc_select_placeholder')"
          icon-name="more"
          hidden-option
          collapse-tags
          value-key="id"
          prop-label="fullname"
          @visible-change="dialogVisible=true"
        >
          <template
            slot='tag'
            slot-scope='{ data }'
          >
            <yxtbiz-user-name :name="data.currentLabel" />
          </template>
        </yxt-select>
        <div class="color-gray-7">{{$t('pc_select_max_min', [1, 200])}}</div>
      </yxt-form-item>
    </yxt-form>
    <div slot="footer">
      <yxt-button
        plain
        @click="handleCancel"
      >{{$t('pc_cancel_mini')}}</yxt-button>
      <yxt-button
        type='primary'
        @click="handleOk"
      >{{$t('pc_ok_mini')}}</yxt-button>
    </div>
    <yxt-drawer
      ref="selectDrawer"
      :header-border='false'
      :destroy-on-close="true"
      size="960px"
      :visible.sync="dialogVisible"
    >
      <yxtbiz-range-selector
        ref="selector"
        :selected="formData.users"
        @change='users=$event'
        model="array"
        :tabs="['persons', 'advance']"
        :function-code='functionCode'
        :data-permission-code='dataPermissionCode'
        >
      </yxtbiz-range-selector>
      <div slot='footer'>
        <yxt-button
          @click="dialogVisible=false"
          plain
        >{{$t('pc_cancel')}}</yxt-button>
        <yxt-button
          type="primary"
          @click="selectUserOk"
        >{{$t('pc_ok')}}</yxt-button>
      </div>
    </yxt-drawer>
  </yxt-drawer>
</template>
<script>
export default {
  inject: [ 'functionCode', 'dataPermissionCode' ],
  props: {
    default: Object
  },
  data() {
    return {
      visible: true,
      dialogVisible: false,
      formData: {
        selType: 0,
        selRange: 0,
        auditType: 0,
        users: []
      },
      rules: {
        users: [
          { required: true, message: this.$t('pc_select_role_p'), trigger: 'blur' }
        ]
      },
      users: []
    };
  },
  watch: {
    default: {
      immediate: true,
      handler(v) {
        // eslint-disable-next-line no-unused-vars
        const { appters, ...others } = this.formData;
        if (v.appters) {
          this.users = this.formData.users = v.appters.map(it => ({
            id: it.userId,
            fullname: it.fullName
          }));
        }
        for (const k in others) {
          if (typeof v[k] !== 'undefined') {
            this.formData[k] = v[k];
          }
        }
      }
    }
  },
  methods: {
    handleVisible(v) {
      this.$emit('update:visible', v);
    },
    handleCancel() {
      this.visible = false;
      this.handleVisible(false);
    },
    handleOk() {
      this.$refs.formRef.validate((isOk) => {
        if (isOk) {
          const { users, ...others } = this.formData;
          others.appters = users.map(it => ({
            userId: it.id,
            fullName: it.fullname
          }));
          this.$emit('click:ok', others);
        }
      });
    },
    closeSelect(done) {
      done(this.$refs.selector.showTip);
    },
    selectUserOk() {
      if (this.users.length > 200 || this.users.length < 1) {
        this.$message.warning(this.$t('pc_select_max_min', [1, 200]));
        return;
      }
      this.formData.users = this.users;
      this.dialogVisible = false;
    }
  }
};
</script>
<style scoped>
.sel-type-item /deep/ .yxt-radio__label {
  display: inline-flex;
  align-items: center;
}

.form-box /deep/ .yxt-select {
  width: 328px;
}
.form-box /deep/ .yxt-form-item{
  margin-bottom: 10px;
}
</style>
